import { Component, OnInit } from '@angular/core';
// Activated Route
import { ActivatedRoute } from '@angular/router';
import { Congreso } from '../../models/congreso.model';
import { CongresosService } from '../../services/services.index';

declare var $;

@Component({
  selector: 'app-inscripto-actividades-list',
  templateUrl: './inscripto-actividades-list.component.html',
  styles: []
})
export class InscriptoActividadesListComponent implements OnInit {

  congreso: Congreso = new Congreso();
  loading: boolean = true;

  constructor(private activatedRoute: ActivatedRoute,
    public _congresosService: CongresosService) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
        this.congreso = data.congreso;
        this.loading = false;
      });
    });
    $(document).ready(function() {
      $('body').tooltip({ selector: '[data-toggle=tooltip]' });
  });
  }

  verInscriptos(i: number) {
    $('#verTooltip_' + i).tooltip('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/inscriptos-actividad/inscripto-actividades-list.component.ts